/**
 * useTenantData — React Query hook returning the full hydrated tenant config.
 *
 * Replaces every `import { ... } from '../data.js'` pattern from omega-club.
 * Cached for 5 min on the client (matching server Cache-Control header);
 * invalidate via `queryClient.invalidateQueries({ queryKey: ['tenant-config', slug] })`
 * after any tenant settings save.
 *
 * Per plan v2.10 Phase 1A #19 (CHAP-33).
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../lib/api.js';
import type { TenantConfig } from '../../shared/types.js';

export function useTenantData(slug: string): UseQueryResult<TenantConfig, Error> {
  return useQuery<TenantConfig, Error>({
    queryKey: ['tenant-config', slug],
    queryFn: () => apiGet<TenantConfig>(`/api/c/${slug}/tenant-config`),
    enabled: Boolean(slug),
  });
}
